const actions = {
  UPDATE_SOIL_COLORS: '[Soil Data] Update Soil Colors',
  updateSoilColors: (data) => ({
    type: actions.UPDATE_SOIL_COLORS,
    payload: data,
  }),
};

export default actions;
